import React, { useContext } from "react";
//
import Tooltip from "@mui/material/Tooltip";
import IconButtonGen from "../../../../../common/components/iconButton/IconButtonGen";
import IconAnalytics from "../../../../../../images/icon_analytics_dark/icon_數據分析.svg";
import Act from "../../../../../store/actions";
import { StoreContext } from "../../../../../store/StoreProvider";

const AnalyticsIconTool = () => {
  const [_, dispatch] = useContext(StoreContext);

  return (
    <div>
      <IconButtonGen
        onClick={() => {
          dispatch({
            type: Act.SNA_ANALYTICS_DISPLAY_WINDOW,
            payload: true,
          });
        }}
        iconSrc={IconAnalytics}
        iconAlt="icon analytics"
        variant="square"
        sx={{
          "&.MuiIconButton-root": {
            backgroundColor: "#e6e9ef",
            boxShadow: "",
          },
        }}
        toolTipTitle="數據分析"
        tooltipPlacement="left"
      />
    </div>
  );
};

export default AnalyticsIconTool;
